import React from 'react';
import Button from 'components/Button';
import { Typography, TypographyVariant } from 'components/Typography';
import './crashFallback.css';

const CrashFallback = () => (
  <div className="crashFallback__container">
    <img className="crashFallback__logo" src="/assets/images1/mrq-logo.svg" alt="MrQ" />
    <div className="crashFallback__content">
      <Typography variant={TypographyVariant.BodyXlStrong}>
        <h1>Oops! Something went wrong.</h1>
      </Typography>
      <Typography variant={TypographyVariant.BodyMd}>
        <p>
          We&apos;re sorry for the inconvenience. Please try refreshing the page or come back later.
        </p>
      </Typography>

      <Button
        title="Refresh"
        buttonText="Refresh"
        type="button"
        onClick={() => window.location.reload()}
      />
    </div>
  </div>
);

export default CrashFallback;
